import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import React from "react";
import { Form, Input, Button } from "antd";

export default function ForgotPasswordPage() {
  const { t } = useTranslation();
    const onFinish = (values: any) => {
        console.log("Reset Password:", values);
    };

    return (
        <>
            <Helmet>
                <title>{t('page.forgot_password')} | Khothi</title>
            </Helmet>
        <div className="min-h-screen px-2 flex items-center auth-wrapper">
            <div className="w-full flex justify-center min-h-screen">

                {/* LEFT IMAGE */}
                <div className="hidden lg:flex items-center justify-center p-6 w-[42%] ml-auto">
                    <img
                        src="https://nexlink.layoutdrop.com/php/demo/assets/images/auth/vector2.svg"
                        alt="auth"
                        className="w-[554px] mx-auto img-fluid"
                    />
                </div>

                {/* RIGHT FORM */}
                <div className="flex items-center justify-center px-3 py-3 lg:px-6 lg:py-8 w-full lg:w-[42%] ml-auto">
                    <div className="bg-white w-full max-w-[450px] rounded-2xl shadow-[0_10px_40px_rgba(0,0,0,0.05)] lg:p-[40px] p-4">

                        {/* Logo */}
                        <div className="text-center mb-6">
                            <a href="/" aria-label="NexLink logo">
                                <img
                                    src="https://nexlink.layoutdrop.com/php/demo/assets/images/logo.svg"
                                    alt="NexLink logo"
                                    className="mx-auto !h-[40px]"
                                />
                            </a>
                        </div>

                        {/* Title */}
                        <div className="text-center mb-[40px]">
                            <h5 className="text-lg !font-semibold !mb-0">
                                Forgot your password?
                            </h5>
                            <p className="text-gray-500 text-sm">
                                Enter your email and we’ll send you instructions to reset it.
                            </p>
                        </div>

                        {/* FORM */}
                        <Form layout="vertical" onFinish={onFinish}>
                            {/* Email */}
                            <Form.Item
                                label="Email Address"
                                name="email"
                                rules={[
                                    { required: true, message: "Please enter your email" },
                                    { type: "email", message: "Invalid email address" },
                                ]}
                            >
                                <Input
                                    size="large"
                                    placeholder="info@example.com"
                                    className="rounded-lg"
                                />
                            </Form.Item>

                            {/* Submit */}
                            <Form.Item className="!mb-3">
                                <Button
                                    htmlType="submit"
                                    size="large"
                                    type="primary"
                                    className="w-full h-11 rounded-lg !bg-[#3e91ab] !text-sm hover:!bg-[#357f96] border-none"
                                >
                                    Send Reset Link
                                </Button>
                            </Form.Item>

                            {/* Back to login */}
                            <p className="text-center text-sm text-gray-500 !mb-0">
                                Remember your password?{" "}
                                <a href="/login" className="!text-[#357f96]">
                                    Sign in here
                                </a>
                            </p>
                        </Form>

                    </div>
                </div>

            </div>
        </div>
        </>
    );

}